module.exports = __webpack_public_path__ + "img/formulaone.92b32a78.svg";